import { render, staticRenderFns } from "./userJournal.vue?vue&type=template&id=e0eeda70&scoped=true&"
import script from "./userJournal.vue?vue&type=script&lang=js&"
export * from "./userJournal.vue?vue&type=script&lang=js&"
import style0 from "./userJournal.vue?vue&type=style&index=0&id=e0eeda70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0eeda70",
  null
  
)

export default component.exports